import { CAMPAIGN_STATUSES } from "campaign/model"
import { FORM_TABS, FORM_TAB_BOXES, IForm } from "form/model"
import { CAMPAIGN_EDIT_PATH, CAMPAIGN_TAB_ID_QUERY_PARAM, DSP_DEAL_EDIT_PATH, FORECAST_EDIT_PATH } from "page/model"
import { navigate } from "page/tools/navigate"
import { getForm } from "./common"
import { loadCampaign } from "./load"
import { hilightTabBox } from "./tab-boxes"

export async function editFormFromSummaryView(
  tab: FORM_TABS,
  isForecast: boolean,
  isDspDeal: boolean,
  tabBox?: FORM_TAB_BOXES
): Promise<void> {
  const form = getForm()
  if (tabBox) {
    hilightTabBox(tabBox)
  }
  navigate({
    path: isForecast ? FORECAST_EDIT_PATH : isDspDeal ? DSP_DEAL_EDIT_PATH : CAMPAIGN_EDIT_PATH,
    pathParams: form.campaignId,
    hashParams: [[CAMPAIGN_TAB_ID_QUERY_PARAM, tab]]
  })
}

export function loadCampaignForEdit(
  campaignId: number,
  campaignStatus: CAMPAIGN_STATUSES,
  isForecast: boolean,
  isDspDeal: boolean,
  tab?: FORM_TABS
): Promise<IForm> {
  return loadCampaign(campaignId, isForecast, isDspDeal, campaignStatus, tab, true)
}
